import { EDisplayType } from '@app/interfaces/screen.interface';
import { ScreenModel } from '@app/models/screen.model';

export function createScreensPreview(): ScreenModel[] {
    return Array.from({ length: 12 }, (_, index) => {
        const number = String(index + 1).padStart(3, '0');
        return new ScreenModel(
            {
                device_id: `DEMO-DEVICE-${number}`,
                serial_number: `DEMO-SN-${number}`,
                ken: `DEMO-KEN-${number}`,
                functional_location: `DEMO-SITE-${Math.floor(index / 3) + 1}`,
                elo_version: index % 2 ? '2.4.1' : '2.5.0',
                linked: index % 3 !== 2,
                displayType: index % 3 === 0 ? EDisplayType.ElevEight : EDisplayType.Device,
                error:
                    index % 4 === 3
                        ? { type: 'KONE', message: 'Demo connection error' }
                        : undefined,
                eleveight: {
                    name: `Demo screen ${number}`,
                    custom_attributes: { vision_enabled: index % 2 === 0 },
                    advertising_attributes: { screen_size: 32 },
                },
            },
            index % 3 === 1,
            index % 4 !== 3,
        );
    });
}
